// @flow
import './CountdownBar.css';

type Props = {
  duration: number,
  paused?: boolean,
};

const CountdownBar = ({ duration, paused = false }: Props) => (
  <div className="countdown-bar" aria-hidden="true">
    <div
      className="countdown-bar-fill"
      style={{
        animationDuration: `${duration}ms`,
        animationPlayState: paused ? 'paused' : 'running',
      }}
    />
  </div>
);

export default CountdownBar;
